import React, { Component } from "react";
import { Button, Input, Radio, Upload, Select, message, Checkbox, Modal, InputNumber, Image, Spin } from 'antd';
import WidgetAjax from "../../widget/WidgetAjax";
import WidgetModal from "./../../widget/WidgetModal";
import Config from "../../config/Config";
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';
import './index.css';
import file from '../../img/business/file.png'
import word from '../../img/business/word.png'
import excel from '../../img/business/excel.png'
import pdf from '../../img/business/pdf.png'
let SystemType = Config.getSystemType();
class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isDemo: Config.isDemo() || false,
            currentIndex: 1,
            userInfo: {},
            randid: '',
            pageInfo: {},
            pageInfo2: {},
            provinceList: [],
            provinceStr: '',
            cityList: [],
            cityStr: '',
            districtList: [],
            districtStr: '',
            pageList: [],
            fromInfo: {
                ZJ: '',         // 主键ID
                TASKID: '',     // 任务ID
                JYZSFZ: '',     // 经营者身份证号
                JYZSJH: '',     // 经营者手机号
                XNJYRS: '',     // 吸纳就业人数
                JNSBRS: '',     // 缴纳社保人数
                YYSR: '',       // 营业收入(万元)
                JLR: '',        // 净利润(万元)
                PROFILE: '',    // 个体户简介
                SQTYPE: '',     // 申请类型 1名 2 特 3优 4新
                SUMSCORE: '',   // 当前申请项总得分
                SQRESULTS: '',  // 申请指标结果集
                PROVINCE: '',   // 省
                CITY: '',       // 市
                COUNTY: '',     // 区
                ISBF: '',       // 是否帮扶
            },
            seeInfo: {
                previewOpen: false,
                previewTitle: '',
                previewImage: '',
            },
            templateInfo: {},
            modal: null,
            modelOptions: {
                type: 'message',
                title: '提示',
                index: 0,
                label: 1,
                width: 600,
                message: <div className="sg-index-bg">
                    <div className="sd-middle">
                        <img className='sg-bg-img1' alt='#' src={require('../../img/business/complete.png')} />
                    </div>
                    <div className="sg-filling-layer">申报信息已提交审核，在申报期前都</div>
                    <div className="sg-filling-layer">可对资料进行修改和完善</div>
                </div>,
                isNext: false,
                isOk: true,
                wrapClassName: 'sg-index-model',
                bodyStyle: { padding: 0 },
            },
            isHide: true,
            choiceInfo: {
                '1': {
                    imgUrl: require('../../img/business/fillingBg1.png'),
                    label: '1',
                    name: '“名”，即知名',
                    tips: '“名”即“知名”个体工商户：产品和服务质量好、诚信经营、有一定品牌影响力；在县级及以上行政区域或在相关网络平台有较高市场占有率或知名度；拥有商标品牌且有一定知晓度；在“小个专”党建方面获得过荣誉等。'
                },
                '2': {
                    imgUrl: require('../../img/business/fillingBg4.png'),
                    label: '2',
                    name: '“特”，即特色',
                    tips: '“特”即“特色”个体工商户：依托区域文化和旅游资源，经营旅游接待、传统手工艺制作、土特产品销售、特色餐饮服务等地方特色产品和特色服务，经营理念或经营方式独特，具有代表性；持有或使用绿色食品、有机食品、地理标志认定登记或商标、名特优新农产品证书等。'
                },
                '3': {
                    imgUrl: require('../../img/business/fillingBg3.png'),
                    label: '3',
                    name: '“优”，即优质',
                    tips: '“优”即“优质”个体工商户：执着坚守、长期经营超过一定年限；拥有县级以上政府认定的老字号、非遗工坊、非物质文化遗产代表性传承人、乡村工匠等传统文化标志；经营者获得相关职业资格证书或技能荣誉；经营者拥有相关专业技术职称并实际从事关联行业；取得相关管理体系认证或产品质量认证等。'
                },
                '4': {
                    imgUrl: require('../../img/business/fillingBg2.png'),
                    label: '4',
                    name: '“新”，即新兴',
                    tips: '“新”即“新兴”个体工商户：率先从事新技术、新产业、新业态、新模式经营，在当地发挥引领示范作用，有效带动产业发展和周边群众致富；依托互联网从事网络创作、自媒体、直播带货等经营活动，在相关平台的美誉度高、粉丝量或用户数量大，经营状况良好等。'
                }
            },
            choiceList: [],
            information: {},
            showLoading: false
        }
        this.onOk = this.onOk.bind(this);
        this.onOkClick = this.onOkClick.bind(this);
        this.submitBtnFn = this.submitBtnFn.bind(this)
    }
    componentDidMount() {
        this.setState({
            currentIndex: 1
        })
        if (this.props.location.state.SQID) {
            this.getUserInfo()
            this.querySqHisList(this.props.location.state.SQID)
        } else {
            this.setState({
                provinceStr: this.props.location.state.PROVINCE,
                cityStr: this.props.location.state.CITY,
                districtStr: this.props.location.state.COUNTY,
            })
            this.getUserInfo()
            this.getProvincialUrbanAreas()
            // this.queryProvince("D111001")
            // this.querySetting()
            this.getTemplateInfo()
        }

    }
    getProvincialUrbanAreas() {
        let { fromInfo } = this.state
        let ProvincialUrbanAreas = []
        let defaultValue = []
        if (localStorage.getItem("ProvincialUrbanAreas")) {
            ProvincialUrbanAreas = localStorage.getItem("ProvincialUrbanAreas").split(',')
        }
        if (localStorage.getItem("defaultValue")) {
            defaultValue = localStorage.getItem("defaultValue").split(',')
        }
        if (ProvincialUrbanAreas.length === 3 && defaultValue.length === 3) {
            this.setState({
                provinceStr: defaultValue[0],
                cityStr: defaultValue[1],
                districtStr: defaultValue[2],
                information: {
                    PROVINCE_STR: ProvincialUrbanAreas[0],
                    CITY_STR: ProvincialUrbanAreas[1],
                    COUNTY_STR: ProvincialUrbanAreas[2],
                },
                fromInfo: {
                    ...fromInfo,
                    PROVINCE: defaultValue[0],   // 省
                    CITY: defaultValue[1],       // 市
                    COUNTY: defaultValue.length > 2 ? defaultValue[2] : '',     // 区
                }
            })
        } else if (ProvincialUrbanAreas.length === 2 && defaultValue.length === 2) {
            this.setState({
                provinceStr: defaultValue[0],
                cityStr: defaultValue[1],
                districtStr: '',
                information: {
                    PROVINCE_STR: ProvincialUrbanAreas[0],
                    CITY_STR: ProvincialUrbanAreas[1],
                    COUNTY_STR: '',
                },
                fromInfo: {
                    ...fromInfo,
                    PROVINCE: defaultValue[0],   // 省
                    CITY: defaultValue[1],       // 市
                    COUNTY: '',     // 区
                }
            })
        } else {
            message.success('请返回首页选择申报城市！');
        }
    }
    getTemplateInfo() {
        let { choiceInfo } = this.state
        if (localStorage.getItem("_template_info_")) {
            let data = JSON.parse(localStorage.getItem("_template_info_"))
            let XZMBJH = data.XZMBJH.filter(res => { return res > 0 })
            let pageList = XZMBJH.map(res => { return choiceInfo[res] });

            let ND = data.ND;

            let yearND = parseInt(ND) - 1;

            this.setState({
                choiceList: pageList,
                yearND: yearND,
                year: ND
            })
        } else {
            let data = JSON.parse(localStorage.getItem("_template_info_"))
            this.queryInfo(data)
        }
    }
    queryInfo(item) {
        let { choiceInfo } = this.state
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/template/info',
            params: {
                SSQXID: item.result.COUNTY
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    localStorage.setItem("_template_info_", JSON.stringify(data.result))
                    let XZMBJH = data.result.XZMBJH.filter(res => { return res > 0 })
                    let pageList = XZMBJH.map(res => { return choiceInfo[res] })
                    let ND = data.result.ND;
                    let yearND = parseInt(ND) - 1;
                    this.setState({
                        choiceList: pageList,
                        yearND: yearND,
                        year: ND
                    })
                    this.setFromInfo(item)
                }
            }
        }, this);
    }
    querySqHisList(SQID) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/info',
            params: {
                SQID
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    this.setFromInfo(data)
                    this.getTemplateInfo()
                    this.queryInfo(data)
                    // if(localStorage.getItem("_template_info_")){
                    //     this.setFromInfo(data)
                    //     this.getTemplateInfo()
                    // }else{
                    //     this.queryInfo(data)
                    // }
                }
            }
        }, this);
    }
    setFromInfo(data) {
        this.obtainFilling(data.result.SQTYPE)
        data.result.SQRESULTS.forEach((da, index) => {
            if (da.ZBTMLX === '5') {
                let RESULT = typeof da.RESULT === 'string' ? JSON.parse(da.RESULT) : da.RESULT
                RESULT.forEach((res, i) => {
                    res.index = index
                    if (res.VCHRFILETYPE.indexOf('png') !== -1 || res.VCHRFILETYPE.indexOf('jpeg') !== -1 || res.VCHRFILETYPE.indexOf('jpg') !== -1 || res.VCHRFILETYPE.indexOf('gif') !== -1) {
                        this.queryDownloadImg(res, data.result, i)
                    } else {
                        res.uid = res.ID
                        res.name = res.VCHRORIGINNAME
                        res.status = 'done'
                        if (res.VCHRFILETYPE.indexOf('pdf') !== -1) {
                            res.url = pdf
                        } else if (res.VCHRFILETYPE.indexOf('docx') !== -1 || res.VCHRFILETYPE.indexOf('doc') !== -1) {
                            res.url = word
                        } else if (res.VCHRFILETYPE.indexOf('xlsm') !== -1 || res.VCHRFILETYPE.indexOf('xlsx') !== -1 || res.VCHRFILETYPE.indexOf('xls') !== -1) {
                            res.url = excel
                        } else {
                            res.url = file
                        }
                        res.imgUrl = res.url
                        this.queryDownloadImg(res, data.result, i)
                    }
                })
                da.RESULT = RESULT
            }
        })
        this.setState({
            fromInfo: {
                ZJ: this.props.location.state.SQID,         // 主键ID
                TASKID: this.state.templateInfo.TASKID,     // 任务ID
                JYZSFZ: data.result.JYZSFZ,     // 经营者身份证号
                JYZSJH: data.result.JYZSJH,     // 经营者手机号
                XNJYRS: Number(data.result.XNJYRS),     // 吸纳就业人数
                JNSBRS: Number(data.result.JNSBRS),     // 缴纳社保人数
                YYSR: Number(data.result.YYSR),       // 营业收入(万元)
                JLR: Number(data.result.JLR),        // 净利润(万元)
                PROFILE: data.result.PROFILE,    // 个体户简介
                SQTYPE: Number(data.result.SQTYPE),     // 申请类型 1名 2 特 3优 4新
                SUMSCORE: Number(data.result.SUMSCORE),   // 当前申请项总得分
                SQRESULTS: data.result.SQRESULTS,  // 申请指标结果集
                PROVINCE: data.result.PROVINCE,   // 省
                CITY: data.result.CITY,       // 市
                COUNTY: data.result.COUNTY,     // 区
            },
            randid: this.props.location.state.SQID,
            provinceStr: data.result.PROVINCE,
            cityStr: data.result.CITY,
            districtStr: data.result.COUNTY,
            information: data.result
        })
        // this.queryProvince("D111001")
    }
    arrayBufferToBlob(arrayBuffer, type) {
        //return new Blob([arrayBuffer], { type: filename });
        let blob = new Blob([arrayBuffer], { type: type });
        const blobUrl = URL.createObjectURL(blob);
        return blobUrl;
    }
    queryDownloadImg(obj, pageInfo, i) {
        let fd = new FormData();
        fd.append("id", obj.ID);
        WidgetAjax.downloadFile({
            url: Config.getBasePath() + '/attachment/download',
            params: fd,
            callback: (data) => {
                if (obj.VCHRFILETYPE.indexOf('docx') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('doc') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/msword")
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('xls') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/vnd.ms-excel")
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('xlsx') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('pdf') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/pdf")
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('ppt') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/vnd.ms-powerpoint")
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('pptx') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/vnd.openxmlformats-officedocument.presentationml.presentation")
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                }
                this.getBase64(data).then(item => {
                    obj.imgUrl = item
                    obj.uid = obj.ID
                    obj.name = obj.VCHRORIGINNAME
                    obj.status = 'done'
                    obj.url = item
                    //obj.index = i
                    pageInfo.SQRESULTS && pageInfo.SQRESULTS.length && pageInfo.SQRESULTS.forEach(da => {
                        let info = this.state.pageList.find(res => { return res.ZJ.toString() === da.ZBID.toString() })
                        if (info) {
                            info.RESULT = da.RESULT
                        }
                    })
                    this.setState({
                        pageList: this.state.pageList
                    })
                })

            }
        });
    }
    querySetting() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/businessSystem/setting',
            params: {
                SSQXID: localStorage.getItem("defaultValue")
            },
            callback: (data) => {
                // if(data&&data.status === 0){
                //     this.setState({
                //         settingInfo: data.result
                //     })
                //     if(data.result.STATE==='0' || data.result.SFSB==='1'){
                //         this.goPage();
                //     }
                // }
            }
        }, this);

    };
    getUserInfo() {
        let userInfo = sessionStorage.getItem("_user_info_")
        if (userInfo) {
            let info = JSON.parse(userInfo)
            this.setState({
                userInfo: info
            })
            // 编辑时 不用请求随机ID
            if (!this.props.location.state.SQID) {
                this.queryGetRandid()
            }
            this.queryEntinfo(info)
        }

    }
    queryGetRandid() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/attachment/get_randid',
            params: { CODE: 530304 },
            callback: (data) => {
                if (data && data.status === 0) {
                    this.setState({
                        randid: data.randid
                    })
                }
            }
        }, this);
    }
    queryEntinfo(info) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/entinfo',
            params: {
                UNISCID: info.uniscid
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    let obj = {}
                    for (var i in this.state.userInfo) {
                        obj[i.toUpperCase()] = this.state.userInfo[i]
                    }
                    this.setState({
                        pageInfo: { ...obj, ...data.result },
                        pageInfo2: { ...obj, ...data.result }
                    })
                }
            }
        }, this);
    }
    queryProvince(type, filter, code) {
        let obj = {
            code: type,
            hierarchy: 1,
        }
        if (filter && code) {
            obj.filter = "${" + filter + "}=" + code
        }
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/widget/dimension',
            params: {
                dimension: obj
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    data.results[0].values.forEach(da => {
                        da.label = da.name
                    })

                    if (!filter && !code) {
                        this.setState({
                            provinceList: data.results[0].values,
                            provinceStr: this.state.provinceStr || data.results[0].values[0].value
                        })
                    }
                    if (filter === 'D111001' && !this.state.cityList.length) {
                        this.setState({
                            cityList: data.results[0].values,
                            cityStr: this.state.cityStr || data.results[0].values[1].value
                        })
                    }
                    if (filter === 'D111002' && !this.state.districtList.length) {
                        this.setState({
                            districtList: data.results[0].values,
                            districtStr: this.state.districtStr || data.results[0].values[0].value
                        })
                    }
                    if (!this.state.cityList.length) {
                        this.queryProvince('D111002', 'D111001', this.state.provinceStr)
                    }
                    if (!this.state.districtList.length && this.state.cityList.length) {
                        this.queryProvince('D111003', 'D111002', this.state.cityStr)
                    }
                }
            }
        }, this);
    }
    goPage() {
        window.history.back(-1)
    };
    onRef = (ref) => {
        this.modal = ref;
    };
    goIndex() {
        this.props.history.push({ pathname: "/home/index", state: {} });
    }
    onOk(type) {
        if (this.state.modelOptions.label === 1) {
            this.props.history.push({ pathname: "/home/guide", state: {} });
        } else {
            this.submitBtnFn()
        }
    }
    onOkClick(type) {
        if (this.state.modelOptions.label === 1) {
            this.goPage()
        } else {
            //this.submitBtnFn()
        }
    }
    removePreview(file, res) {
        let pageList = this.state.pageList
        let indexOne = null
        indexOne = pageList.findIndex(item => { return item.ZJ_STR === res.ZJ_STR })
        // if(!this.props.location.state.SQID){
        //     indexOne = pageList.findIndex(item=>{return item.ZJ_STR === res.ZJ_STR})
        // }else{
        //     indexOne = pageList.findIndex(item=>{return item.ZBID === res.ZBID})
        // }
        if (pageList.length === 1) {
            pageList[indexOne].RESULT = []
        } else {
            let index = pageList[indexOne].RESULT.findIndex(da => { return da.ID === file.ID })
            pageList[indexOne].RESULT.splice(index, 1)
        }
        this.setState((prevState, props) => ({
            pageList: pageList
        }));
        this.queryDel(file)
    };
    queryDel(file) {
        WidgetAjax.downloadFile({
            url: Config.getBasePath() + '/attachment/del',
            params: {
                FILEID: file.ID
            },
            callback: (data) => {

            }
        });
    }
    seeImg(file) {
        if (file.fileUrl) {
            window.open(file.fileUrl)
            return
        }
        let seeInfo = this.state.seeInfo
        seeInfo = {
            previewOpen: true,
            previewTitle: file.name,
            previewImage: file.url,
        }
        this.setState({
            seeInfo: seeInfo
        })
    }
    addResult(obj, res) {
        obj.uid = obj.ID
     
        obj.status = 'done'
        obj.url = obj.imgUrl
        obj.index = res.i
        let pageList = this.state.pageList
        if (!pageList[res.i].RESULT) {
            pageList[res.i].RESULT = [obj]
        } else {
            pageList[res.i].RESULT.push(obj)
        }
        this.setState((prevState, props) => ({
            pageList: pageList,
            showLoading: false
        }));
    }
    queryAttachmentList(res, arr) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/attachment/list',
            params: {
                ENTITYID: res.ENTITYID,
                DOMAIN: res.DOMAIN
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    let obj = {}
                    let pageList = this.state.pageList
                    let result = pageList[res.i].RESULT
                    if (result.length === 0) {
                        obj = data.results[data.results.length - 1]
                    } else {
                        let str = arr[0]
                        obj = data.results.find(res => { return res.ID === str })
                    }
                    if (obj.VCHRFILETYPE.indexOf('png') !== -1 || obj.VCHRFILETYPE.indexOf('jpeg') !== -1 || obj.VCHRFILETYPE.indexOf('jpg') !== -1 || obj.VCHRFILETYPE.indexOf('gif') !== -1) {
                        this.queryDownload(obj, res)
                    } else {
                        if (obj.VCHRFILETYPE.indexOf('pdf') !== -1) {
                            obj.imgUrl = pdf
                        } else if (obj.VCHRFILETYPE.indexOf('word') !== -1 || obj.VCHRFILETYPE.indexOf('docx') !== -1 || obj.VCHRFILETYPE.indexOf('doc') !== -1) {
                            obj.imgUrl = word
                        } else if (obj.VCHRFILETYPE.indexOf('xlsm') !== -1 || obj.VCHRFILETYPE.indexOf('xlsx') !== -1 || obj.VCHRFILETYPE.indexOf('xls') !== -1) {
                            obj.imgUrl = excel
                        } else {
                            obj.imgUrl = file
                        }
                        // obj.imgUrl=file
                        this.queryDownload(obj, res)
                        // this.addResult(obj,res)
                    }

                }
            }
        }, this);
    }
    getBase64(data) {
        return new Promise((resolve, reject) => {
            const blob = new Blob([data], { type: "image/jpeg" }); //类型一定要写！！！
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }
    queryDownload(obj, res) {
        let fd = new FormData();
        fd.append("id", obj.ID);
        WidgetAjax.downloadFile({
            url: Config.getBasePath() + '/attachment/download',
            params: fd,
            callback: (data) => {
                if (obj.VCHRFILETYPE.indexOf('docx') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
                    this.addResult(obj, res)
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('doc') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/msword")
                    this.addResult(obj, res)
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('xls') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/vnd.ms-excel")
                    this.addResult(obj, res)
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('xlsx') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                    this.addResult(obj, res)
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('pdf') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/pdf")
                    this.addResult(obj, res)
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('ppt') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/vnd.ms-powerpoint")
                    this.addResult(obj, res)
                    return
                }
                if (obj.VCHRFILETYPE.indexOf('pptx') !== -1) {
                    obj.fileUrl = this.arrayBufferToBlob(data, "application/vnd.openxmlformats-officedocument.presentationml.presentation")
                    this.addResult(obj, res)
                    return
                }
                this.getBase64(data).then(item => {
                    obj.imgUrl = item
                    this.addResult(obj, res)
                })

            }
        });
    }
    obtainFilling(value) {
        const SQTYPE_OBJ = {
            '1': '“名”，即知名',
            '2': '“特”，即特色',
            '3': '“优”，即优质',
            '4': '“新”即“新兴”',
        }
        let templateArr = JSON.parse(localStorage.getItem("_template_info_"))
        let templateObj = {
            '1': 'ZMMB',
            '2': 'TSMB',
            '3': 'YXMB',
            '4': 'XXMB'
        }
        let obj = templateObj[value]

        if (templateArr[obj]) {
            templateArr[obj] = templateArr[obj] || []
        }
        templateArr[obj].forEach(da => {
            if (da.ZBBZZ) {
                try {
                    da.ZBBZZ = JSON.parse(da.ZBBZZ)
                } catch (err) {
                    console.log(err)
                }
            }
            if (da.ZBTMLX === '5') {
                da.RESULT = []
            } else {
                da.RESULT = ''
            }

        })
        if (this.state.information && this.state.information.SQRESULTS && this.state.information.SQRESULTS.length > 0 && value === this.state.information.SQTYPE) {
            templateArr[obj] = this.state.information.SQRESULTS
        }
        templateArr[obj].forEach(da => {
            if (da.ZBBZZ && typeof da.ZBBZZ === "string") {
                da.ZBBZZ = JSON.parse(da.ZBBZZ)
            }
        })
        this.setState({
            pageList: templateArr[obj],
            templateInfo: templateArr
        })
    }
    nextBtn() {

        const { isDemo } = this.state;

        if (Number(this.state.currentIndex) === 1) {
            if (!this.state.provinceStr) {
                message.error({
                    content: '请选择省份',
                    style: { marginTop: '30vh' }
                });
                return
            }
            if (!this.state.cityStr) {
                message.error({
                    content: '请选择城市',
                    style: { marginTop: '30vh' }
                });
                return
            }
            if (!this.state.provinceStr && !this.state.cityStr && !this.state.districtStr) {
                message.error({
                    content: '请选择区县',
                    style: { marginTop: '30vh' }
                });
                return
            }
            if (!this.state.fromInfo.JYZSFZ) {
                message.error({
                    content: '请输入经营者身份证号',
                    style: { marginTop: '30vh' }
                });
                return
            }

            if (SystemType === 'sso') {
                const patternMainLand = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
                const patternHongkong = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
                // const patternTaiwan = /^[a-z]{1}\d{8,}$/;
                const patternTaiwan = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
                const patternMacao = /^[1|5|7][0-9]{6}\([0-9A-Za-z]\)/;
                if (patternMainLand.test(this.state.fromInfo.JYZSFZ) ||
                    patternHongkong.test(this.state.fromInfo.JYZSFZ) ||
                    patternTaiwan.test(this.state.fromInfo.JYZSFZ) ||
                    patternMacao.test(this.state.fromInfo.JYZSFZ)
                ) {
                    // console.log('大陆'+patternMainLand.test(this.state.fromInfo.JYZSFZ),'香港'+patternHongkong.test(this.state.fromInfo.JYZSFZ),'台湾'+patternTaiwan.test(this.state.fromInfo.JYZSFZ),'澳门'+patternMacao.test(this.state.fromInfo.JYZSFZ));
                } else {
                    message.error({
                        content: '请输入正确的身份证号码',
                        style: { marginTop: '30vh' }
                    })
                    return
                }
            }

      
            if (!this.state.fromInfo.JYZSJH) {
                message.error({
                    content: '请输入经营者手机号码',
                    style: { marginTop: '30vh' }
                });
                return
            }
            if (!/^1[3,4,5,6,7,8,9][0-9]{9}$/.test(this.state.fromInfo.JYZSJH)) {
                message.error({
                    content: '请输入正确的手机号码',
                    style: { marginTop: '30vh' }
                });
                return
            }
            if (typeof this.state.fromInfo.XNJYRS !== "number") {
                message.error({
                    content: '请输入吸纳就业人数',
                    style: { marginTop: '30vh' }
                });
                return
            }
            if (typeof this.state.fromInfo.JNSBRS !== "number") {
                message.error({
                    content: '请输入缴纳社保人数',
                    style: { marginTop: '30vh' }
                });
                return
            }
            if (typeof this.state.fromInfo.YYSR !== "number") {
                message.error({
                    content: '请输入营业收入',
                    style: { marginTop: '30vh' }
                });
                return
            }
            if (typeof this.state.fromInfo.JLR !== "number") {
                message.error({
                    content: '请输入净利润',
                    style: { marginTop: '30vh' }
                });
                return
            }
            if (!this.state.fromInfo.PROFILE) {
                message.error({
                    content: '请输入个体工商户介绍',
                    style: { marginTop: '30vh' }
                });
                return
            }
            // if (!this.props.location.state.SQID) {
                WidgetAjax.ajax({
                    url: Config.getBasePath() + '/businessSystem/checkIdCard',
                    params: {
                        JYZSFZ: this.state.fromInfo.JYZSFZ,
                        COUNTY: this.state.districtStr
                    },
                    callback: (data) => {
                        if (data && data.status === 0) {
                            if (data.result.SFSB === 1 || data.result.SFSB === '1') {
                                message.error({
                                    content: '您已在该身份下进行过信息申报，请检查身份证信息以及选择区县！',
                                    style: { marginTop: '30vh' }
                                });
                            } else {
                                let num = this.state.currentIndex
                                this.setState({
                                    currentIndex: num + 1
                                })
                            }
                        }
                    }
                }, this);
            // } else {
            //     let num = this.state.currentIndex
            //     this.setState({
            //         currentIndex: num + 1
            //     })
            // }
            return
        }
        if (this.state.currentIndex === 2) {
            if (!this.state.fromInfo.SQTYPE) {
                message.error({
                    content: '请选择一个填报类型',
                    style: { marginTop: '30vh' }
                });
                return
            }
            let num = this.state.currentIndex
            this.setState({
                currentIndex: num + 1
            })
        }

    }
    uplodImg(file, res, item) {
        if (file.file.size > 5242880) {
            message.error({
                content: '文件大小超出限制',
                style: { marginTop: '30vh' }
            });
            return
        }
        this.setState({
            showLoading: item.ZJ
        })
        let fd = new FormData();
        fd.append("file", file.file);
        fd.append("DOMAIN", file.data.DOMAIN);
        fd.append("ENTITYID", file.data.ENTITYID);
        WidgetAjax.ajax({
            url: file.action,
            params: fd,
            callback: (data) => {
                if (data && data.status === 0) {
                    let result = data.result.replace(/\[|]/g, '').split(',')
                    this.queryAttachmentList(file.data, result)
                }
            }
        }, this);
    }
    backBtn() {
        let num = this.state.currentIndex
        this.setState({
            currentIndex: num - 1
        })
    }
    changeProvince(e) {
        this.setState({
            provinceStr: e,
            cityList: [],
            cityStr: '',
            districtList: [],
            districtStr: ''
        })
        this.queryProvince('D111002', 'D111001', e)
    }
    changeCity(e) {
        this.setState({
            cityStr: e,
            districtList: [],
            districtStr: ''
        })
        this.queryProvince('D111003', 'D111002', e)
    }
    changeDistrict(e) {
        this.setState({
            districtStr: e
        })
    }
    changeRadio(e) {
        let { fromInfo } = this.state
        this.setState({
            fromInfo: {
                ...fromInfo,
                SQTYPE: e
            }
        })
        this.obtainFilling(e)
    }
    changeArr(e, i) {
        let pageList = this.state.pageList
        pageList[i].RESULT = e.target.value
        this.setState({
            pageList: pageList
        })
    }
    changeCheckbox(e, i) {
        let pageList = this.state.pageList
        pageList[i].RESULT = e
        this.setState({
            pageList: pageList
        })
    }
    submitBtn(num) {
        const { fromInfo, districtStr } = this.state;
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/template/info',
            params: {
                SSQXID: fromInfo.COUNTY || districtStr
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    console.log('data.result')
                    console.log(data.result)
                    let endTimeStr = `${data.result.ENDTIME} 23:59:59`
                    let endTimeNum = new Date(endTimeStr).getTime()
                    if (new Date().getTime() > endTimeNum && !this.props.location.state.SQID) {
                        message.success('评审期已结束，无法继续申报！');
                    } else {
                        this.setTipsQuery(num)
                    }
                }
            }
        }, this);
    }
    setTipsQuery(num) {
        const { modelOptions } = this.state;
        // eslint-disable-next-line
        this.state.fromInfo.SFTJ = num === 0 ? 'N' : 'Y'
        if (num === 0) {
            this.submitBtnFn()
            return
        }
        let isInfo = this.state.pageList.find(res => { return (res.SFBT === 1 || res.SFBT === '1' || res.SFBT === '是') && (!res.RESULT || !res.RESULT.length) })
        if (isInfo) {
            let str = `请填写必填项${isInfo.ZBMC}`
            message.error(str);
            return
        }
        modelOptions.label = 2
        modelOptions.width = 600
        modelOptions.okText = '确认'

        modelOptions.message = <div className="sg-index-bg">
            <div className="sd-middle" style={{ margin: '20px 0' }}>
                <svg t="1688104158159" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3910" width="40" height="40"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296z m32 440c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z" fill="#ff0000" p-id="3911"></path></svg>
            </div>
            <div className="sg-filling-layer a11">您确认提交申报信息吗？</div>
            <div className="sg-filling-layer b11">请确认申报信息准确无误，可在申报期内进行修改，进入审核后将不可修改</div>
        </div>
        this.setState({
            modelOptions: modelOptions,
        })
        this.modal.open();
    }
    submitBtnFn() {
        let pageList = this.state.pageList
        let fromInfo = this.state.fromInfo
        console.log(pageList,fromInfo);
        let arr = []
        pageList.forEach(da => {
            let obj = {
                ZBMC: da.ZBMC,
                RESULT: da.RESULT,
                SCORE: 0,
                ZBTMLX: da.ZBTMLX,
                ZBID: da.ZBID || da.ZJ_STR
            }
            if (da.ZBTMLX === '2') {
                let info = da.ZBBZZ.find(res => { return res.name === da.RESULT })
                obj.SCORE = info ? info.score : "0"
            }
            if (da.ZBTMLX === '3') {
                let list = da.ZBBZZ.filter(res => { return da.RESULT.indexOf(res.name) > -1 })
                obj.SCORE = da.RESULT && da.RESULT !== '[]' && da.RESULT !== '{}' && da.RESULT !== 'undefined' && da.RESULT !== 'null' && da.RESULT !== 'Null' && da.RESULT !== 'NULL' ? list.reduce((total, num) => { return total + num.score }, 0) : 0
                obj.RESULT = JSON.stringify(obj.RESULT)
            }
            if (da.ZBTMLX === '1') {
                // let info = da.ZBBZZ.find(res=>{return res.name === da.RESULT})
                obj.SCORE = da.RESULT === '是' ? da.ZBNUM : 0
            }
            if (da.ZBTMLX === '4') {
                obj.SCORE = da.RESULT && da.RESULT !== '[]' && da.RESULT !== '{}' && da.RESULT !== 'undefined' && da.RESULT !== 'null' && da.RESULT !== 'Null' && da.RESULT !== 'NULL' ? da.ZBNUM : 0
            }
            if (da.ZBTMLX === '5') {
                let arr = []
                obj.RESULT.forEach(da => {
                    arr.push({ ID: da.ID, VCHRFILETYPE: da.VCHRFILETYPE ,VCHRSTORAGENAME:da.VCHRSTORAGENAME })
                })
                obj.RESULT = JSON.stringify(arr)
                obj.SCORE = obj.RESULT && obj.RESULT !== '[]' && obj.RESULT !== '{}' && obj.RESULT !== 'undefined' && obj.RESULT !== 'null' && obj.RESULT !== 'Null' && obj.RESULT !== 'NULL' ? da.ZBNUM : 0
            }
            arr.push(obj)
        })
        fromInfo.SUMSCORE = arr.reduce((total, num) => { let count = num.RESULT && num.RESULT !== '[]' && num.RESULT !== '{}' && num.RESULT !== 'undefined' && num.RESULT !== 'null' && num.RESULT !== 'Null' && num.RESULT !== 'NULL' ? Number(num.SCORE) : 0; return total + count }, 0)
        fromInfo.SQRESULTS = arr
        // fromInfo.PROVINCE = this.state.provinceStr
        // fromInfo.CITY = this.state.cityStr
        // fromInfo.COUNTY = this.state.districtStr
        fromInfo.TASKID = this.state.templateInfo.TASKID
        fromInfo.ZJ = this.state.randid
        fromInfo.ISBF = this.props.location.state.isGiveService === 'true' ? 1 : 0
        //fromInfo.SFTJ = num === 0 ? 'N' : 'Y'
        console.log(fromInfo,'fromInfo');
        if (this.props.location.state.SQID) {
            this.queryUpdate(fromInfo)
        } else {
            this.queryCreate(fromInfo)
        }
    }
    queryUpdate(params) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/update',
            params: params,
            callback: (data) => {
                if (data && data.status === 0) {
                    // modelOptions.label = 1
                    // modelOptions.message = <div className="sg-index-bg">
                    //     <div className="sd-middle">
                    //         <img className='sg-bg-img1' alt='#' src={require('../../img/business/complete.png')} />
                    //     </div>
                    //     <div className="sg-filling-layer">申报信息已提交审核，在申报期前都</div>
                    //     <div className="sg-filling-layer">可对资料进行修改和完善</div>
                    // </div>
                    // this.setState({
                    //     modelOptions: modelOptions,
                    // })
                    // this.modal.open();
                    message.success('申报信息已提交成功！');
                    this.props.history.push({ pathname: "/home/guide", state: {} });
                } else {
                    message.success(data.message);
                }
            }
        }, this);
    }
    queryCreate(params) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/create',
            params: params,
            callback: (data) => {
                if (data && data.status === 0) {
                    // modelOptions.label = 1
                    // modelOptions.message = <div className="sg-index-bg">
                    //     <div className="sd-middle">
                    //         <img className='sg-bg-img1' alt='#' src={require('../../img/business/complete.png')} />
                    //     </div>
                    //     <div className="sg-filling-layer">申报信息已提交审核，在申报期前都</div>
                    //     <div className="sg-filling-layer">可对资料进行修改和完善</div>
                    // </div>
                    // this.setState({
                    //     modelOptions: modelOptions,
                    // })
                    // this.modal.open();
                    if (params.SFTJ === 'N') {
                        message.success('已保存为草稿！');
                    } else {
                        message.success('申报信息已提交成功！');
                    }
                    this.props.history.push({ pathname: "/home/guide", state: {} });
                } else {
                    console.log('data9999')
                    console.log(data)
                }
            }
        }, this);
    }

    IdCodeValid(code) {
        //身份证号合法性验证  
        //支持15位和18位身份证号  
        //支持地址编码、出生日期、校验位验证  

        const { isDemo } = this.state;
        if (isDemo) {
            if (code) {
                return true;
            }
            else {
                return false;
            }

        }
        else {
            var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
            var row = true;
            var msg = "验证成功";
            // eslint-disable-next-line
            if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(code)) {
                row = false
                msg = "被保人身份证号格式错误";
            }
            else if (!city[code.substr(0, 2)]) {
                row = false
                msg = "被保人身份证号地址编码错误";
            }
            else {
                //18位身份证需要验证最后一位校验位  
                if (code.length === 18) {
                    code = code.split('');
                    //∑(ai×Wi)(mod 11)  
                    //加权因子  
                    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                    //校验位  
                    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                    var sum = 0;
                    var ai = 0;
                    var wi = 0;
                    for (var i = 0; i < 17; i++) {
                        ai = code[i];
                        wi = factor[i];
                        sum += ai * wi;
                    }
                    if (parity[sum % 11].toString() !== code[17].toUpperCase()) {
                        row = false
                        msg = "被保人身份证号校验位错误";
                    }
                }
            }

            return row;
        }


    }
    verifyFile(file, res) {
        if (res.ZBMC === '门头照片/店内环境照片/网店截图等') {
            if (file.type.indexOf('png') === -1 && file.type.indexOf('jpg') === -1 && file.type.indexOf('jpeg') === -1 && file.type.indexOf('gif') === -1) {
                message.error({
                    content: '请上传正确的图片',
                    style: { marginTop: '30vh' }
                });
                return
            }
        } else {
            if (file.size > 5242880) {

                return
            }
        }
    }
    render() {
        const { TextArea } = Input;
        let { showLoading, pageInfo, pageInfo2, fromInfo, provinceList, provinceStr, cityStr, cityList, districtList,
            districtStr, pageList, randid, seeInfo, modelOptions, isHide, templateInfo, choiceList, information, yearND, year = new Date().getFullYear(), isDemo } = this.state
        // let year = new Date().getFullYear()
        let url = `${Config.getBasePath()}/attachment/create`
        const uploadButton = (
            <div className="sg-upload-btn sd-columnCenter">
                <img className='sg-upload-img' alt='#' src={require('../../img/business/upload.png')} />
                <div className="sg-upload-tips">
                    <div> jpg、gif、png等格式</div>
                    <div> 最多可上传五张图片,每个材料大小不超过5M</div>
                </div>
            </div>
        );
        const uploadButton2 = (
            <div className="sg-upload-btn sd-columnCenter">
                <img className='sg-upload-img' alt='#' src={require('../../img/business/upload.png')} />
                <div className="sg-upload-tips">
                    <div> jpg、gif、png、word、excel、pdf等格式</div>
                    <div>材料数量最多10份,每个材料大小不超过5M</div>

                </div>
            </div>
        );
        const SpinInfo = (
            <div className="sg-upload-loading sd-columnCenter">
                <Spin tip="上传中..." size="large">
                    <div className="content" />
                </Spin>
            </div>
        );
        const ENTTYPE_OBJ = {
            '1': '生存',
            '2': '成长',
            '3': '发展'
        }
        const SQTYPE_OBJ = {
            '1': '“名”，即知名',
            '2': '“特”，即特色',
            '3': '“优”，即优质',
            '4': '“新”，即新兴',
        }
        let imgArr = ['.png', '.jpg', '.jpeg', '.gif']
        let imgArr2 = ['.png', '.jpg', '.jpeg', '.gif', '.docx', '.doc', '.xlsx', '.xls', '.pdf']
        return (
            <div data-component="filling">
                <div className="sg-filling-all">
                    <div className="sg-login-top sd-start">
                        <div onClick={this.goPage} className="sd-start">
                            <img className='sg-information-img22' alt='#' src={require('../../img/business/upPage.png')} />
                            <span className="sg-top-font11" style={{ color: '#357AC5' }}>返回</span>
                        </div>


                    </div>
                    <div className="sg-notice">
                        <div className="sg-img-view" style={{ borderBottom: 'none' }}>
                            <img className='sg-bg-img' alt='#' src={require('../../img/business/group.png')} />
                            <div className="sg-view-center sd-middle">
                                <div className="sg-mean-li sd-end">
                                    <div className="sg-li-round sg-bg1">1</div>
                                    <div className="sg-li-font" style={{ color: '#fff' }}>基础信息</div>
                                </div>
                                <div className="sg-center-line" style={{ width: '1.28125rem' }}></div>
                                <div className="sg-mean-li sd-start">
                                    <div className={`sg-li-round ${this.state.currentIndex > 1 ? 'sg-bg1' : ''}`} style={{}}>2</div>
                                    <div className="sg-li-font" style={{ color: this.state.currentIndex > 1 ? '#fff' : '#DDEDFF' }}>分类标准</div>
                                </div>

                            </div>
                        </div>
                        <div className="sg-notice-center">
                            <div className="sg-center-middle sd-columnCenter" style={{ display: this.state.currentIndex === 1 ? "flex" : "none" }}>
                                <div className="sg-middle-list">
                                    <div className="sg-center-top sd-start sg-border11">
                                        <span className="sg-center-font">申报任务：{year}年“名特优新" 申报评定</span>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-left sd-start">
                                            <div className="sg-li-title sg-left-none"><span style={{ color: '#ff0000', marginRight: '6px', opacity: 0 }}>*</span>个体工商户名称/字号：</div>
                                            <div className="sg-li-li sd-start"><Input placeholder=" " bordered={false} disabled={true} value={pageInfo.ENTNAME || pageInfo2.ENTNAME} /></div>
                                        </div>
                                        <div className="sg-li-right sd-start">
                                            <div className="sg-li-title"><span style={{ color: '#ff0000', marginRight: '6px', opacity: 0 }}>*</span>统一社会信用代码：</div>
                                            <div className="sg-li-li sd-start"><Input placeholder=" " bordered={false} disabled={true} value={pageInfo.UNISCID || pageInfo2.UNISCID} /></div>
                                        </div>

                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-left sd-start">
                                            <div className="sg-li-title sg-left-none"><span style={{ color: '#ff0000', marginRight: '6px', opacity: 0 }}>*</span>经营者姓名：</div>
                                            <div className="sg-li-li sd-start"><Input placeholder=" " bordered={false} disabled={true} value={pageInfo.NAME || pageInfo2.NAME} /></div>
                                        </div>
                                        <div className="sg-li-right sd-start">
                                            <div className="sg-li-title"><span style={{ color: '#ff0000', marginRight: '6px', opacity: 0 }}>*</span>注册日期：</div>
                                            <div className="sg-li-li sd-start"><Input placeholder=" " bordered={false} disabled={true} value={pageInfo.ESTDATE || pageInfo2.ESTDATE} /></div>
                                        </div>

                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none"><span style={{ color: '#ff0000', marginRight: '6px', opacity: 0 }}>*</span>经营范围:</div>
                                        <div className="sg-li-li sd-start" style={{ padding: '0 11px' }}>{pageInfo.OPSCOPE || pageInfo2.OPSCOPE}</div>
                                    </div>

                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-left sd-start">
                                            <div className="sg-li-title sg-left-none"><span style={{ color: '#ff0000', marginRight: '6px', opacity: 0 }}>*</span>组成形式：</div>
                                            <div className="sg-li-li sd-start"><Input placeholder=" " disabled={true} value={pageInfo.COMPFORM || pageInfo2.COMPFORM} bordered={false} /></div>
                                        </div>
                                        <div className="sg-li-right sd-start">
                                            <div className="sg-li-title"><span style={{ color: '#ff0000', marginRight: '6px', opacity: 0 }}>*</span>登记机关：</div>
                                            <div className="sg-li-li sd-start"><Input placeholder=" " bordered={false} disabled={true} value={pageInfo.REGORG} /></div>
                                        </div>

                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-left sd-start">
                                            <div className="sg-li-title sg-left-none"><span style={{ color: '#ff0000', marginRight: '6px', opacity: 0 }}>*</span>经营场所：</div>
                                            <div className="sg-li-li sd-start"><Input placeholder=" " disabled={true} value={pageInfo.OPLOC || pageInfo2.OPLOC} bordered={false} /></div>
                                        </div>
                                        {/* <div className="sg-li-right sd-start">
                                            <div className="sg-li-title"><span style={{color:'#ff0000',marginRight:'6px',opacity: 0}}>*</span>三型：</div>
                                            <div className="sg-li-li sd-start"><Input placeholder=" " bordered={false} disabled={true} value={ENTTYPE_OBJ[pageInfo.ENTTYPE_SX]}/></div>
                                        </div> */}
                                    </div>

                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-left sd-start">
                                            <div className="sg-li-title sg-left-none"><span style={{ color: '#ff0000', marginRight: '6px', opacity: 0 }}>*</span>省份/地市/区县：</div>
                                            <div className="sg-li-li sd-start" key={provinceStr + cityStr + districtStr}>
                                                <div className="li-li-li">{information.PROVINCE_STR}</div>
                                                <div className="li-li-li" style={{ display: information.PROVINCE_STR == information.CITY_STR ? 'none' : 'flex' }}>{information.CITY_STR}</div>
                                                <div className="li-li-li">{information.COUNTY_STR}</div>
                                                {/* <Select placeholder="省份" defaultValue={provinceStr} className="li-li-li" disabled options={provinceList} onChange={(e)=>this.changeProvince(e)}/>
                                                <Select placeholder="地市" defaultValue={cityStr} className="li-li-li" disabled options={cityList} onChange={(e)=>this.changeCity(e)}/>
                                                <Select placeholder="区县" defaultValue={districtStr} className="li-li-li" disabled options={districtList} onChange={(e)=>this.changeDistrict(e)}/> */}
                                            </div>
                                        </div>
                                        <div className="sg-li-right sd-start" onClick={() => { this.goIndex() }}><div className="sg-li-title" style={{ textDecoration: 'underline', cursor: 'pointer', width: '100%', textAlign: 'left', color: '#ff0000' }}><span style={{ display: this.props.location.state.SQID ? 'none' : 'inline-block', color: '#ff0000', marginRight: '6px', opacity: 0 }}>*</span>{this.props.location.state.SQID ? '' : '请确认个体工商户所在省市区县，如有错误。请返回首页进行修改。'}</div></div>
                                    </div>

                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-left sd-start">
                                            <div className="sg-li-title sg-left-none"><span style={{ color: '#ff0000', marginRight: '6px' }}>*</span>经营者身份证号：</div>
                                            <div className="sg-li-li sd-start" >
                                                <Input placeholder="请输入" maxLength={18} value={fromInfo.JYZSFZ} onChange={(e) => this.setState({ fromInfo: { ...fromInfo, JYZSFZ: e.target.value } })} bordered={false} />
                                                {/* <div className="sg-li-tips" style={{display:fromInfo.JYZSFZ?'none':'block'}}>{"请输入经营者身份证号" }</div> */}
                                            </div>
                                        </div>
                                        <div className="sg-li-right sd-start">
                                            <div className="sg-li-title"><span style={{ color: '#ff0000', marginRight: '6px' }}>*</span>经营者手机号码：</div>
                                            <div className="sg-li-li sd-start" >
                                                {/* <InputNumber placeholder="请输入" style={{border:!fromInfo.JYZSJH||/^1[3,4,5,6,7,8,9][0-9]{9}$/.test(fromInfo.JYZSJH)?'':'1px solid #ff0000'}} min={0} max={19999999999} value={fromInfo.JYZSJH} onChange={(value)=>this.setState({fromInfo:{...fromInfo,JYZSJH:value}})} bordered={false} controls={false}/> */}
                                                <Input placeholder="请输入" maxLength={11} style={{ border: !fromInfo.JYZSJH || /^1[3,4,5,6,7,8,9][0-9]{9}$/.test(fromInfo.JYZSJH) ? '' : '1px solid #ff0000' }} value={fromInfo.JYZSJH} onChange={(e) => this.setState({ fromInfo: { ...fromInfo, JYZSJH: e.target.value } })} bordered={false} />
                                                <div className="sg-li-tips" style={{ display: !fromInfo.JYZSJH || /^1[3,4,5,6,7,8,9][0-9]{9}$/.test(fromInfo.JYZSJH) ? 'none' : 'block' }}>经营者手机号码格式错误</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none"><span style={{ color: '#ff0000', marginRight: '6px' }}>*</span>吸纳就业人数（人)：</div>
                                        <div className="sg-li-li sd-start">
                                            <InputNumber placeholder="包括经营者在内的全职、兼职人员总数" min={0} max={9999999999} value={fromInfo.XNJYRS} onChange={(value) => this.setState({ fromInfo: { ...fromInfo, XNJYRS: value } })} bordered={false} controls={false} />
                                        </div>
                                        <div className="sg-li-title"><span style={{ color: '#ff0000', marginRight: '6px' }}>*</span>缴纳社保人数（人）:</div>
                                        <div className="sg-li-li sd-start">
                                            <InputNumber placeholder="吸纳就业人数中缴纳社保的人数" min={0} max={9999999999} value={fromInfo.JNSBRS} onChange={(value) => this.setState({ fromInfo: { ...fromInfo, JNSBRS: value } })} bordered={false} controls={false} />
                                        </div>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none"><span style={{ color: '#ff0000', marginRight: '6px' }}>*</span>年营业收入<span style={{ color: 'red' }}>（万元）</span>:</div>
                                        <div className="sg-li-li sd-start">
                                            <InputNumber placeholder={'上一年度营业收入'} min={0} max={9999999999} value={fromInfo.YYSR} onChange={(value) => this.setState({ fromInfo: { ...fromInfo, YYSR: value } })} bordered={false} controls={false} />
                                        </div>
                                        <div className="sg-li-title"><span style={{ color: '#ff0000', marginRight: '6px' }}>*</span>年净利润<span style={{ color: 'red' }}>（万元）</span>:</div>
                                        <div className="sg-li-li sd-start">
                                            <InputNumber placeholder={'上一年度净利润'} min={0} max={9999999999} value={fromInfo.JLR} onChange={(value) => this.setState({ fromInfo: { ...fromInfo, JLR: value } })} bordered={false} controls={false} />
                                        </div>
                                    </div>

                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none"><span style={{ color: '#ff0000', marginRight: '6px' }}>*</span>个体工商户介绍/简介:</div>
                                        <div className="sg-li-TextArea sd-start">
                                            <TextArea className="sg-textArea" value={fromInfo.PROFILE} onChange={(e) => this.setState({ fromInfo: { ...fromInfo, PROFILE: e.target.value } })} bordered={false} showCount maxLength={1000} style={{ height: 130, resize: 'none', border: 'none' }} placeholder="请填写关于您申报的个体工商户的介绍，此内容将在认定成功后向社会公示，请认真填写" />
                                            <span className="sg-TextArea-label">{fromInfo.PROFILE.length || 0}/<span style={{ color: '#333' }}>1000</span></span>
                                        </div>
                                    </div>

                                    {
                                        templateInfo.JCMB && templateInfo.JCMB.length && templateInfo.JCMB.map((res, index) => {
                                            if (res.ZBFL === '9') {
                                                return <div className="sg-list-li sd-spaceBetween" key={index}>
                                                    <div className="sg-li-title sg-left-none">{res.ZBMC}:</div>
                                                    <div className="sg-li-li sd-start"><Input placeholder=" " bordered={false} value={res.RESULT} /></div>
                                                </div>
                                            } else {
                                                return ''
                                            }
                                        })
                                    }
                                </div>
                                <div className="sg-middle-list sd-middle" style={{ paddingTop: '48px', paddingBottom: '30px' }}>
                                    <Button className="sg-list-btn" onClick={this.goPage}>取消</Button>
                                    <Button type="primary" className="sg-list-btn" style={{ background: '#357AC5', borderColor: '#357AC5' }} onClick={() => { this.nextBtn() }}>下一步</Button>
                                </div>
                            </div>

                            <div className="sg-center-middle sd-columnCenter" style={{ display: this.state.currentIndex === 2 ? "flex" : "none" }}>
                                <div className="sg-middle-tips sd-start">注：“名”、“特”、“优”、“新”的评定标准，根据个体工商户实际情况，只允许选择一种进行描述，并且不可重复申报。</div>

                                <div className="sg-middle-center sd-spaceBetween sd-wrap">
                                    {
                                        choiceList && choiceList.length > 0 && choiceList.map(res => {
                                            return <div className="sg-mean-li" key={res.label}>
                                                <img className='sg-center-img' alt='#' src={res.imgUrl} />
                                                <div className="sg-li-layer">
                                                    <div className="sd-start">
                                                        <Radio className="sg-layer-radio" value={res.label} checked={fromInfo.SQTYPE.toString() === res.label.toString()} onChange={(e) => this.changeRadio(res.label)}>{res.name}</Radio>
                                                    </div>
                                                    <div className="sg-layer-tips">{res.tips}</div>
                                                </div>
                                            </div>
                                        })
                                    }
                                    <div className="sg-mean-li" ></div>
                                    <div className="sg-mean-li" ></div>
                                    <div className="sg-mean-li" ></div>
                                    {/* <div className="sg-mean-li" key={1}>
                                        <img className='sg-center-img' alt='#' src={require('../../img/business/fillingBg1.png')} />
                                        <div className="sg-li-layer">
                                            <div className="sd-start">
                                                <Radio className="sg-layer-radio" value={1} checked={fromInfo.SQTYPE===1} onChange={(e)=>this.changeRadio(e)}>“名”，即知名</Radio>
                                            </div>
                                            <div className="sg-layer-tips">“名”即“知名”个体工商户：产品和服务质量好、诚信经营、有一定品牌影响力；在县级及以上行政区域或在相关网络平台有较高市场占有率或知名度；拥有商标品牌且有一定知晓度；在“小个专”党建方面获得过荣誉等。</div>
                                        </div>
                                    </div>

                                    <div className="sg-mean-li" key={2}>
                                        <img className='sg-center-img' alt='#' src={require('../../img/business/fillingBg4.png')} />
                                        <div className="sg-li-layer">
                                            <div className="sd-start">
                                                <Radio className="sg-layer-radio" value={2} checked={fromInfo.SQTYPE===2} onChange={(e)=>this.changeRadio(e)}>“特”，即特色</Radio>
                                            </div>
                                            <div className="sg-layer-tips">“特”即“特色”个体工商户：持有或使用地理标志商标；经营地方特色产品和特色服务，具有代表性；经营理念或经营方式独特，在县级及以上行政区域内有知名度等。</div>
                                        </div>
                                    </div>

                                    <div className="sg-mean-li" key={3}>
                                        <img className='sg-center-img' alt='#' src={require('../../img/business/fillingBg3.png')} />
                                        <div className="sg-li-layer">
                                            <div className="sd-start">
                                                <Radio className="sg-layer-radio" value={3} checked={fromInfo.SQTYPE===3} onChange={(e)=>this.changeRadio(e)}>“优”，即优质</Radio>
                                            </div>
                                            <div className="sg-layer-tips">“优”即“优质”个体工商户：拥有县级以上政府认定的“老字号”、非物质文化遗产传承人等传统文化标志；经营者持有曾获二级及以上职业资格证书或相关技能荣誉；经营者拥有中级及以上专业技术职称并从事关联行业；执着坚守、长期经营超过一定年限；取得相关管理体系认证或产品质量认证等。</div>
                                        </div>
                                    </div>

                                    <div className="sg-mean-li" key={4}>
                                        <img className='sg-center-img' alt='#' src={require('../../img/business/fillingBg2.png')} />
                                        <div className="sg-li-layer">
                                            <div className="sd-start">
                                                <Radio className="sg-layer-radio" value={4} checked={fromInfo.SQTYPE===4} onChange={(e)=>this.changeRadio(e)}>“新”，即新型</Radio>
                                            </div>
                                            <div className="sg-layer-tips">“新”即“新型”个体工商户：率先从事新技术、新产业、新业态、新模式经营，在当地发挥引领示范作用，有效带动产业发展和周边群众致富；依托互联网从事网络创作、自媒体、直播带货等经营活动，在相关平台的美誉度高、粉丝量或用户数量大，经营状况良好等。</div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="sg-middle-list sd-middle" style={{ paddingTop: '47px', paddingBottom: '32px' }}>
                                    <Button className="sg-list-btn" onClick={() => { this.backBtn() }}>上一步</Button>
                                    <Button type="primary" className="sg-list-btn" style={{ background: '#357AC5' }} onClick={() => { this.nextBtn() }}>下一步</Button>
                                </div>
                            </div>

                            <div className="sg-center-middle sd-columnCenter" style={{ display: this.state.currentIndex === 3 ? "flex" : "none" }}>
                                <div className="sg-middle-title sg-layer-radio sd-middle">{SQTYPE_OBJ[fromInfo.SQTYPE]}</div>
                                <div className="sg-middle-list sg-fence" style={{ background: '#FAFAFA' }}>
                                    {
                                        pageList.map((res, i) => {
                                            let str = null
                                            if (res.ZBTMLX === '1') {
                                                str = <div className="sg-center-ul" key={i}>
                                                    <div className="sg-ul-title"><span className="sg-color1" style={{ display: res.SFBT === 1 || res.SFBT === '1' || res.SFBT === '是' ? "inline-block" : "none" }}>*</span>{i + 1}.{res.ZBMC}</div>
                                                    <div className="sg-ul-tips">{res.ZBJS}</div>
                                                    <div className="sg-ul-li">
                                                        <Radio.Group onChange={(e) => this.changeArr(e, i)} value={res.RESULT}>
                                                            <Radio value='是'>是</Radio>
                                                            <Radio value='否' className="sg-li-margin">否</Radio>
                                                        </Radio.Group>
                                                    </div>
                                                </div>
                                            }
                                            if (res.ZBTMLX === '2' && res.ZBBZZ) {
                                                str = <div className="sg-center-ul" key={i}>
                                                    <div className="sg-ul-title"><span className="sg-color1" style={{ display: res.SFBT === 1 || res.SFBT === '1' || res.SFBT === '是' ? "inline-block" : "none" }}>*</span>{i + 1}.{res.ZBMC}</div>
                                                    <div className="sg-ul-tips">{res.ZBJS}</div>
                                                    <div className="sg-ul-li">
                                                        <Radio.Group onChange={(e) => this.changeArr(e, i)} value={res.RESULT}>
                                                            {
                                                                res.ZBBZZ.map((item, num) => {
                                                                    return <Radio value={item.name}>{item.name}</Radio>
                                                                })
                                                            }
                                                        </Radio.Group>
                                                    </div>
                                                </div>
                                            }
                                            if (res.ZBTMLX === '3' && res.ZBBZZ) {
                                                str = <div className="sg-center-ul" key={i}>
                                                    <div className="sg-ul-title"><span className="sg-color1" style={{ display: res.SFBT === 1 || res.SFBT === '1' || res.SFBT === '是' ? "inline-block" : "none" }}>*</span>{i + 1}.{res.ZBMC}</div>
                                                    <div className="sg-ul-tips">{res.ZBJS}</div>
                                                    <div className="sg-ul-li">
                                                        <Checkbox.Group onChange={(e) => this.changeCheckbox(e, i)} value={res.RESULT}>
                                                            {
                                                                res.ZBBZZ.map((item, num) => {
                                                                    return <Checkbox value={item.name}>{item.name}</Checkbox>
                                                                })
                                                            }
                                                        </Checkbox.Group>
                                                    </div>
                                                </div>
                                            }
                                            if (res.ZBTMLX === '4') {
                                                str = <div className="sg-center-ul" key={i}>
                                                    <div className="sg-ul-title"><span className="sg-color1" style={{ display: res.SFBT === 1 || res.SFBT === '1' || res.SFBT === '是' ? "inline-block" : "none" }}>*</span>{i + 1}.{res.ZBMC}</div>
                                                    <div className="sg-ul-tips">{res.ZBJS}</div>
                                                    <div className="sg-ul-li">
                                                        <TextArea className="sg-textArea sg-border" showCount maxLength={1000} style={{ height: 130, resize: 'none', border: '1px solid #D6D4D4' }} placeholder={res.ZBJS || '请输入'} value={res.RESULT} onChange={(e) => this.changeArr(e, i)} />
                                                    </div>
                                                </div>
                                            }
                                            if (res.ZBTMLX === '5') {
                                                str = <div className="sg-center-ul" key={i}>
                                                    <div className="sg-ul-title"><span className="sg-color1" style={{ display: res.SFBT === 1 || res.SFBT === '1' || res.SFBT === '是' ? "inline-block" : "none" }}>*</span>{i + 1}.{res.ZBMC}</div>
                                                    <div className="sg-ul-tips" style={{ display: res.ZBJS && res.ZBMC !== '门头照片/店内环境照片/网店截图等' ? "block" : "none" }}>{res.ZBJS}</div>
                                                    <div className="sg-ul-tips" style={{ display: res.ZBMC === '门头照片/店内环境照片/网店截图等' ? "block" : "none" }}>1.若您是线下实体店铺，请上传清晰的门头照片及店内环境照片 </div>
                                                    <div className="sg-ul-tips" style={{ display: res.ZBMC === '门头照片/店内环境照片/网店截图等' ? "block" : "none" }}>2.若您是线上网店店铺，请上传网店首页的截图 </div>
                                                    <div className="sg-ul-upload sd-start">
                                                        <div className="sg-ul-img-li" style={{ display: res.ZBMC === '门头照片/店内环境照片/网店截图等' ? "block" : "none" }}>
                                                            <div className="sg-diagram-img">示例图</div>
                                                            <Image className='sg-img-li' src={require('../../img/business/tipsImg1.jpg')} />
                                                        </div>
                                                        <div className="sg-ul-img-li" style={{ display: res.ZBMC === '门头照片/店内环境照片/网店截图等' ? "block" : "none" }}>
                                                            <div className="sg-diagram-img">示例图</div>
                                                            <Image className='sg-img-li' src={require('../../img/business/tipsImg2.jpg')} />
                                                        </div>
                                                        <div className="sg-ul-img-li" style={{ display: res.ZBMC === '门头照片/店内环境照片/网店截图等' ? "block" : "none" }}>
                                                            <div className="sg-diagram-img">示例图</div>
                                                            <Image className='sg-img-li' src={require('../../img/business/tipsImg3.png')} />
                                                        </div>
                                                        <Upload
                                                            action={url}
                                                            data={{
                                                                DOMAIN: 'QYFJ' + res.ZJ_STR,
                                                                ENTITYID: randid,
                                                                i: i,
                                                                name: res.ZBMC
                                                            }}
                                                            accept={res.ZBMC === '门头照片/店内环境照片/网店截图等' ? imgArr.join(',') : imgArr2.join(',')}
                                                            customRequest={(file, i) => { this.uplodImg(file, i, res) }}
                                                            beforeUpload={(file) => { this.verifyFile(file, res) }}
                                                            listType="picture-card"
                                                            fileList={res.RESULT}
                                                            onPreview={(file) => { this.seeImg(file) }}
                                                            onRemove={(file) => { this.removePreview(file, res) }}>
                                                            {(res.ZBMC === '门头照片/店内环境照片/网店截图等' ? 5 : 10) <= res.RESULT.length ? null : res.ZBMC === '门头照片/店内环境照片/网店截图等' ? showLoading == res.ZJ ? SpinInfo : uploadButton : showLoading == res.ZJ ? SpinInfo : uploadButton2}
                                                        </Upload>
                                                        <Modal open={seeInfo.previewOpen} title={seeInfo.previewTitle} footer={null} onCancel={(e) => this.setState({ seeInfo: { ...seeInfo, previewOpen: false } })}>
                                                            <img alt="#" style={{ width: '100%' }} src={seeInfo.previewImage} />
                                                        </Modal>
                                                    </div>
                                                </div>
                                            }
                                            return str
                                        })
                                    }
                                </div>
                                <div className="sg-middle-list sd-middle" style={{ paddingTop: '48px', paddingBottom: '32px' }}>
                                    <Button className="sg-list-btn" onClick={() => { this.backBtn() }}>上一步</Button>
                                    <Button className="sg-list-btn sg-button-line" onClick={() => { this.submitBtn(0) }} style={{ display: this.props.location.state.SQID && this.props.location.state.SFTJ === 'Y' ? 'none' : 'block' }}>保存为草稿</Button>
                                    {/* <Button type="primary" className="sg-list-btn" style={{background:'#357AC5'}} onClick={()=>{this.submitBtn(1)}}>{this.props.location.state.SQID?'保存':'提交'}</Button> */}
                                    <Button type="primary" className="sg-list-btn" style={{ background: '#357AC5' }} onClick={() => { this.submitBtn(1) }}>提交</Button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <WidgetModal options={modelOptions} onRef={this.onRef} isHide={isHide} onOk={this.onOk} onOkClick={this.onOkClick} onCancel={this.onOkClick}></WidgetModal>
                </div>
            </div>
        )
    }
}

export default Index
